window.storefrontPopup = function storefrontPopup() {
    var storeFrontPopup = $('.js_storefrontPopup');

    if (storeFrontPopup.length > 0) {
        $('.js_storefrontPopup').mtcOverlay({
            buttonHtml: '<div class="overlayCloseButton storefrontPopupClose"><a href="#"><img src="/sites/petervardy/images/svgs/times-regular-white.svg" alt="Close Popup" /></a></div>',
            contentClass: 'storefrontPopup',
            padding: '16px',
            beforeOpen: function () {
                $('.overlayBox .breadcrumbWrap').remove();
                $('.overlayBox .itemKeySpecialOffer').remove();
                $('.overlayBox .contactGroupNew').remove();
                $('.overlayBox .itemLocationWrap').remove();
            }
        });
    }
}

$(document).ready(function () {
    storefrontPopup();
});
